import {getCountryList} from "@/api/api";

export default {
    watch: {
        '$i18n.locale'() {
            // 检查是否已经加载过国家列表，如果是，则不重新加载
            if (this.countryOptions.length > 0) {
                this.translateCountryOptions();
                return;
            }

            this.fetchCountryOptions();
        },
    },
    data() {
        return {
            countryOptions: [],
            countriesLoaded: false, // 新增字段用于标识国家列表是否已加载
        };
    },

    methods: {
        async fetchCountryOptions() {
            if (!this.countriesLoaded) {
                try {
                    // 调用后端新接口获取国家列表数据（不需要token）
                    const response = await getCountryList();
                    // 将后端返回的国家列表数据转换为前端需要的格式
                    this.countryOptions = response.data.map(country => {
                        let label = country.name;
                        let code = country.code || country.country_code || country.code2;
                        if (code) {
                            try {
                                const translatedLabel = this.$t(`countries.${code}`);
                                if (translatedLabel !== `countries.${code}`) {
                                    label = translatedLabel;
                                }
                            } catch (e) {
                                // 如果翻译失败，使用国家名称作为默认值
                            }
                        }
                        return {
                            value: country.id,
                            code: code,
                            label: label
                        };
                    });
                    // 按照国家名称字母顺序排序
                    this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
                    this.countriesLoaded = true; // 标记国家列表已加载
                } catch (error) {
                    // 加载失败时使用默认国家列表
                    this.countryOptions = [
                        { value: 1, code: 'CN', label: this.$t('countries.CN') },
                        { value: 2, code: 'US', label: this.$t('countries.US') },
                        { value: 3, code: 'JP', label: this.$t('countries.JP') },
                        { value: 4, code: 'GB', label: this.$t('countries.GB') },
                        { value: 5, code: 'DE', label: this.$t('countries.DE') },
                        { value: 6, code: 'FR', label: this.$t('countries.FR') },
                        { value: 7, code: 'IT', label: this.$t('countries.IT') },
                        { value: 8, code: 'ES', label: this.$t('countries.ES') }
                    ];
                    // 按照国家名称字母顺序排序
                    this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
                    this.countriesLoaded = true;
                }
            }
        },
        translateCountryOptions() {
            // 仅在语言改变时重新翻译国家列表的标签
            this.countryOptions.forEach(option => {
                try {
                    if (option.code) {
                        // 尝试使用原始代码查找翻译
                        const translatedLabel = this.$t(`countries.${option.code}`);
                        // 如果翻译结果不是 "countries.xxx"，使用翻译结果
                        if (translatedLabel !== `countries.${option.code}`) {
                            option.label = translatedLabel;
                        }
                    }
                } catch (e) {
                    // 如果翻译失败，使用默认标签
                }
            });
            // 重新按照国家名称字母顺序排序
            this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
        },
    },
};